module.exports = "/static/assets/08dff6089c2812aaac7dc2ceed178351.png";